"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.configs', function () {
    this.options = {};
    this.getUrl = function (type, name) {
        return namespace_1.default.params.paths[type].config + '/' + type + '.' + name + '.config.js?cb=' + namespace_1.default.params.cachebreaker;
    };
    this.getLoader = function () {
        return new namespace_1.default.loader.configs();
    };
    this.load = function (files, type, deferred) {
        var _this = this;
        var defArr = [];
        files.forEach(function (value) {
            var loader = _this.getLoader();
            var defObj = jquery_1.default.Deferred();
            var changedOptions = _this.options;
            changedOptions['url'] = _this.getUrl(type, value);
            changedOptions['jsonpCallback'] = 'apaCallbackConfig' + namespace_1.default.formatting.firstUpperCase(value) + namespace_1.default.formatting.firstUpperCase(type);
            changedOptions['deferred'] = defObj;
            defArr.push(defObj);
            loader.namespace = value;
            loader.setOptions(changedOptions);
            loader.load();
        });
        jquery_1.default.when.apply(this, defArr).then(function () {
            deferred.resolve();
        });
    };
});
